import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppBarService {
  titleAppBar = new BehaviorSubject<string>(null);
  constructor() {}
}
